import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import Container from '@material-ui/core/Container';

const useStyles = makeStyles((darkTheme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: darkTheme.spacing(2),
    margin: 'auto',
    maxWidth: 1000,
    borderRadius: 18,
  },
  image: {
    width: 128,
    height: 128,
  },
  img: {
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  },
}));

export default function Sections(data) {
  const classes = useStyles();
  return (
    <Container className={classes.root}>
      <Paper className={classes.paper}>
        <Grid container spacing={2}>
          <Grid item>
            <ButtonBase className={classes.image}>
              <img
                className={classes.img}
                alt="complex"
                src={require(`../static/${data.props.img.replace("'", '')}.png`)}
              />
            </ButtonBase>
          </Grid>
          <Grid item sm={12} md container>
            <Grid item sm container direction="column" spacing={2}>
              <Grid item sm>
                <Typography gutterBottom variant="subtitle1">
                  {data.props.title}
                </Typography>
                <Typography variant="body2" gutterBottom>
                  {data.props.content}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
}
